import GppBadIcon from '@mui/icons-material/GppBad';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { Box, Card, Grid, Stack, Typography } from '@mui/material';
import { alpha, styled, useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Label from '../../components/Label';

const RootStyle = styled(Card)(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  flexDirection: 'column',
  padding: theme.spacing(3),
  [theme.breakpoints.up(414)]: {
    padding: theme.spacing(5),
  },
  // boxShadow: theme.customShadows.z8,
  borderWidth: `1px !important`,
  borderColor: `${alpha(theme.palette.grey[500], 1)} !important`,

  // Adding transition for smooth effect
  transition: 'transform 0.3s ease-out',
}));

const PricingPlanCard = ({
  name,
  price,
  id,
  selectedPlan,
  handlePlan,
  plan_validity,
  no_of_users,
  has_cname,
  currency_symbol,
  currentPlanDetails,
}) => {
  const { t: translate } = useTranslation();
  const isCurrentPlan = currentPlanDetails?.paid_plan_name === name;
  const theme = useTheme();
  const handleChangePlan = (id) => {
    handlePlan(id);
  };
  const getBackGroundColor = () => {
    const lightGreen = theme.palette.pricing.lightGreen;
    const lightRed = `linear-gradient(140deg, #00C853 0%, #B9F6CA 100%)`;
    return isCurrentPlan ? lightRed : selectedPlan?.id === id ? lightGreen : '';
  };

  return (
    <Grid container sx={{ p: 1 }}>
      {/* Main Plan Details */}
      <Grid item xs={12}>
        <RootStyle style={{ background: getBackGroundColor() }} onClick={() => handleChangePlan(id)}>
          {isCurrentPlan && (
            <Label sx={{ top: { xs: 4, sm: 16 }, right: { xs: 8, sm: 16 }, position: 'absolute', background: 'white' }}>
              {translate('trail_plan.current_plan')}
            </Label>
          )}
          <Typography variant="overline" sx={{ color: 'text.secondary' }}>
            {name.replace('_', ' ')}
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', my: 2 }}>
            <Typography variant="h4" sx={{ mx: 1 }}>
              {price === 0 ? 'Free' : `${currency_symbol}${price}`}
            </Typography>
            {price !== 0 && (
              <Typography
                gutterBottom
                component="span"
                variant="subtitle2"
                sx={{ alignSelf: 'flex-end', color: 'text.secondary' }}
              >
                /{plan_validity === 30 ? translate('trail_plan.monthly') : translate('trail_plan.yearly')}
              </Typography>
            )}
          </Box>

          <Stack component="ul" spacing={2} sx={{ my: 2 }}>
            <Stack
              component="li"
              direction="row"
              alignItems="center"
              spacing={1.5}
              sx={{ typography: 'body2', color: 'text.primary' }}
            >
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 20, height: 20 }} />
              <Typography sx={{ color: theme.palette.pricing.grey, fontWeight: 800 }} variant="body2">
                {`${no_of_users} ${translate('trail_plan.no_of_users')}`}
              </Typography>
            </Stack>
            <Stack
              component="li"
              direction="row"
              alignItems="center"
              spacing={1.5}
              sx={{ typography: 'body2', color: 'text.primary' }}
            >
              {has_cname ? (
                <VerifiedUserIcon sx={{ color: 'success.dark', width: 20, height: 20 }} />
              ) : (
                <GppBadIcon sx={{ color: 'error.main', width: 20, height: 20 }} />
              )}
              <Typography sx={{ color: theme.palette.pricing.grey, fontWeight: 800 }} variant="body2">
                {translate('trail_plan.white_label')}
              </Typography>
            </Stack>
          </Stack>
        </RootStyle>
      </Grid>
    </Grid>
  );
};

export default PricingPlanCard;
